import React, { useMemo } from "react";
import { Route, Routes } from "react-router-dom";
import ErrorPage from "../components/ErrorPage/Error";
import SCAILayout from "../components/SCAILayout";
import { ROUTES_PATH } from "../utils/EndPoints";
import PrivateRoute from "./PrivateRoute";
import MyProfile from "../pages/MyProfile";
import OTP from "../pages/OTP";
import { processNodeAndPermissions } from "../helper/com-helper";
import { DT } from "../utils/RouteHelper/DTRM/DT";
import PublicRoute from "./PublicRoute";
import LandingLogin from "../pages/Login/LandingLogin";
import SSOCallback from "../pages/SSOCallback";
import { SCAI_FRONTEND_ROUTES } from "../utils/const";
import { SCAIFrontendParams } from "../constant/constant";
import SCAIFrontendWrapper from "../pages/SCAIFrontends";
import AuthRouter from "../pages/NewLogin/AuthRouter";

const Routing = () => {
  const mapRoutes = (container, containerName, Component) => {
    let { routes } = processNodeAndPermissions(container);
    if (containerName === "RM") {
      const DTRoutes = processNodeAndPermissions(DT)?.routes;
      routes = routes.filter((path) => !DTRoutes.includes(path));
    }
    return routes.map((routePath) => (
      <Route
        key={`${containerName}-${routePath}`}
        path={routePath}
        element={
          <PrivateRoute path={routePath}>
            <Component key={containerName} {...SCAIFrontendParams[containerName]} />
          </PrivateRoute>
        }
      />
    ));
  };

  const allRoutes = useMemo(
    () =>
      SCAI_FRONTEND_ROUTES.flatMap(({ routes, key }) =>
        mapRoutes(routes, key, SCAIFrontendWrapper)
      ),
    []
  );

  return (
    <Routes>
      {/* PUBLIC ROUTES */}
      <Route
        path="/"
        element={
          <PublicRoute>
            <AuthRouter />

            {/* <LandingLogin /> */}
          </PublicRoute>
        }
      />

      <Route
        path="/complete/azuread-oauth2/"
        element={
          <PublicRoute>
            <SSOCallback />
          </PublicRoute>
        }
      />

      <Route
        path="/scai"
        element={
          <PublicRoute>
            <AuthRouter />

            {/* <LandingLogin /> */}
          </PublicRoute>
        }
      />

      <Route
        path="/login/callback"
        element={
          <PublicRoute>
            <AuthRouter />

            {/* <LandingLogin /> */}
          </PublicRoute>
        }
      />

      <Route
        path="/reset-password/"
        element={
          <PublicRoute>
            <AuthRouter />

            {/* <LandingLogin /> */}
          </PublicRoute>
        }
      />

      <Route path="/scai/login-mfa" element={<OTP />} />
      <Route
        path={ROUTES_PATH.MY_PROFILE}
        element={
          <SCAILayout>
            <MyProfile />
          </SCAILayout>
        }
      />

      {/* DYNAMIC ROUTES */}
      {allRoutes}

      {/* WILDCARD */}
      <Route path="*" element={<ErrorPage />} />
    </Routes>
  );
};

export default Routing;
